export enum RetPolicyTag {
  LegalHold = 'LegalHold',
  PolicyName = 'PolicyName',
  ServiceType = 'ServiceType'
}
export const RetPolicyTagsMap = new Map<RetPolicyTag, { tag: string; prop: string }>([
  [RetPolicyTag.PolicyName, { tag: 'Policy name', prop: 'Name' }],
  [RetPolicyTag.ServiceType, { tag: 'Service type', prop: 'ServiceType' }],
  [RetPolicyTag.LegalHold, { tag: 'Disabled', prop: 'HasLegalHold' }]
]);
